import { apiClient } from "../../../lib";

export interface ProjectSearchResponse {
  status: boolean;
  http_code: number;
  message: string;
  response_time: string;
  meta_data: any;
  data: Projects[];
}

export interface Projects {
  id: number;
  title: string;
  description: string;
  project_status: string;
  region_name: string;
  area_name: any;
  portfolio_name: string;
  programme_name: string;
  programme_id: number;
  portfolio_id: number;
}

export const projectApi = {
    fetchProjects: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
         if (params?.my_tasks) {
       searchParams.append("assign_to_me", "true");
     }
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/projects?${queryString}`);
        return response.data;
    },
    searchProjects: async (params?: Record<string, any>): Promise<ProjectSearchResponse> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/projects/search?${queryString}`);
        return response.data;
    },
    pinProjects: async ({ id, status }: { id: string, status: boolean }): Promise<any> => {
        const response = status ? await apiClient.post(`/projects/${id}/pinned`) : await apiClient.delete(`/projects/${id}/pinned`);
        return response.data;
    },
    fetchProjectStages: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        if (params?.my_tasks) {
            searchParams.append("assign_to_me", "true");
        }
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/projects/quick-filter?${queryString}`);
        return response.data;
    },
    createProject: async (params: Record<string, any>): Promise<any> => {
        const response = await apiClient.post('/projects', params);
        return response.data;
    },
    editProject: async ({ projectId, payload }: { projectId: string, payload: any }): Promise<any> => {
        const response = await apiClient.put(`/projects/${projectId}`, payload);
        return response.data;
    },
    getFormDetails: async (params?: Record<string, any>): Promise<any> => {
        const response = await apiClient.get('/projects/details', {
            params: {
                ...params,
            },
        });
        return response.data;
    },
    archiveProject: async(projectId: string, isArchived: boolean) => {
        const response = await apiClient.patch(`projects/${projectId}/archive`, { is_archived: isArchived});
        return response.data;
    }
};